/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { createContext, type MutableRefObject } from 'react';
import { triggerGTMEventApp } from '../utils/triggerGTMEvent/triggerGTMEvent';

export type GTMContextValue = {
	triggerGTMEvent: typeof triggerGTMEventApp;
	shouldEmitConversionEvent: MutableRefObject<boolean>;
};

export const GTMContext = createContext<GTMContextValue>( {
	triggerGTMEvent: triggerGTMEventApp,
	shouldEmitConversionEvent: { current: true }
} );
